export function isoToZoneParts(iso: string, timezone: string): { date: string; time: string } {
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const d = new Date(iso);
  // A missing/unparseable `iso` must not crash Intl.DateTimeFormat.formatToParts —
  // fall back to "now" so callers keep rendering instead of throwing mid-render.
  if (Number.isNaN(d.getTime())) return isoToZoneParts(new Date().toISOString(), tz);
  const df = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  const parts = df.formatToParts(d);
  const y = parts.find(p => p.type === 'year')?.value || '0000';
  const m = parts.find(p => p.type === 'month')?.value || '01';
  const da = parts.find(p => p.type === 'day')?.value || '01';
  const h = parts.find(p => p.type === 'hour')?.value || '00';
  const mi = parts.find(p => p.type === 'minute')?.value || '00';
  return { date: `${y}-${m}-${da}`, time: `${h}:${mi}` };
}

export function getNowInSelectedTZParts(timezone: string): { todayStr: string; hour: string; minute: number } {
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const nowDate = new Date();
  const df = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  const parts = df.formatToParts(nowDate);
  const y = parts.find(p => p.type === 'year')?.value || '0000';
  const m = parts.find(p => p.type === 'month')?.value || '01';
  const da = parts.find(p => p.type === 'day')?.value || '01';
  const h = parts.find(p => p.type === 'hour')?.value || '00';
  const mi = parseInt(parts.find(p => p.type === 'minute')?.value || '0', 10);
  return { todayStr: `${y}-${m}-${da}`, hour: h, minute: isNaN(mi) ? 0 : mi };
}

export function localTzToUTC(dateStr: string, timeStr: string, tz: string): Date {
  const [Y, M, D] = dateStr.split('-').map(Number);
  const [H, Min] = timeStr.split(':').map(Number);
  const guess = new Date(Date.UTC(Y || 0, (M || 1) - 1, D || 1, H || 0, Min || 0));
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  const parts = fmt.formatToParts(guess);
  const y2 = Number(parts.find(p => p.type === 'year')?.value || '0');
  const m2 = Number(parts.find(p => p.type === 'month')?.value || '1');
  const d2 = Number(parts.find(p => p.type === 'day')?.value || '1');
  const h2 = Number(parts.find(p => p.type === 'hour')?.value || '0');
  const mi2 = Number(parts.find(p => p.type === 'minute')?.value || '0');
  const desiredTotal = (H || 0) * 60 + (Min || 0);
  const shownTotal = (h2 || 0) * 60 + (mi2 || 0) + ((y2 !== (Y || 0) || m2 !== (M || 1) || d2 !== (D || 1)) ? (((new Date(y2, (m2 || 1) - 1, d2).getTime() - new Date(Y || 0, (M || 1) - 1, D || 1).getTime()) / 86400000) * 1440) : 0);
  const deltaMin = shownTotal - desiredTotal;
  const corrected = new Date(guess.getTime() - deltaMin * 60000);
  return corrected;
}

